module.exports = __webpack_public_path__ + "img/tsbx.0cd0c472.png";